import { useMutation, useQuery } from "react-query";
import {
  getClientTransaction,
  createPaymentVisitor,
  createPaymentOrder
} from "./requests";
import { Payment } from "../../types";

export { getPaymentCreationErrorMessage } from "./requests";

export const useGetTransaction = (
  id: string,
  isEnabled: boolean,
  shouldPoll = false,
) =>
  useQuery<Payment, any>(
    ['getClientTransaction', id],
    () => getClientTransaction(id),
    {
      enabled: isEnabled && id.length > 0,
      refetchInterval: shouldPoll
        ? (transaction) => (
          !transaction || transaction.status === "1" ? 1500 : false
        )
        : false,
      refetchIntervalInBackground: false,
    },
  );

export const useCreatePaymentVisitor = () => useMutation(createPaymentVisitor);

export const useCreatePaymentOrder = () => useMutation(createPaymentOrder);
